import { RowAppearance } from "../core/shared/grid/grid.model";

export class AbsenceRow implements RowAppearance {
  id: number;
  employeeFullName: string;
  startDate: Date;
  endDate: Date;
  absenceTypeName: string;
  stateInternalName: string;
  employeeId: number;
  reporterId: number;
  absenceDays: number;
  stateName: string;
  description: string;
  rowCustomClass: string;
}

export class Absence {
  isNew: boolean;
  id: number;
  departmentId: number;
  departmentName: string;
  reporterId: number;
  reporterFullName: string;
  employeeId: number;
  employeeFullName: string;
  description: string;
  absenceTypeId: number;
  absenceTypeName: string;
  startDate: Date;
  endDate: Date;
  createdBy: string;
  createdDate: Date;
  absenceStateName: string;
  absenceStateInternalName: string;
  history: AbsenceHistory[];
  notificationEmployees: AbsenceNotificationEmployee[];
}

export class AbsenceHistory {
  id: number;
  employeeId: number;
  employeeFullName: string;
  stateId: number;
  stateName: string;
  stateInternalName: string;
  description: string;
  createdBy: string;
  createdDate: Date;
}

export class AbsenceCurrentUser {
  employeeId: number;
  isSupervisor: Boolean;
}

export enum AbsenceAction {
  Init,
  Confirm,
  Approve,
  Reject,
  Cancel,
  Delete
}

export class NotificationForEmployee {
  id: number;
  notificationEmployeeId: number;
  name: string;
  surname: string;
  email: string;
}

export class AbsenceNotificationEmployee extends NotificationForEmployee {
  absenceId: number;
  constructor(absneceId: number) {
    super();
    this.absenceId = absneceId
  }
}